import Vue from 'vue';

import App from '@/App.vue';

import router from '@/routes/router';
import vuetify from '@/plugins/vuetify';
import VueLogger from 'vuejs-logger';
import VueGtag from 'vue-gtag';

import CmsApi from '@/plugins/api/cms';
import StoreCoreApi from '@/plugins/api/store-core';
import Cls from '@/plugins/cls';
import Gpr from '@/plugins/gpr';
import Msg from '@/plugins/msg';
import i18n from '@/plugins/i18n/locale';
import '@/plugins/validator/index';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ErrHandler from '@/plugins/err-handler';
import VueScrollTo from 'vue-scrollto';

import StoreModule from '@/store/index';

import 'swagger-ui/dist/swagger-ui.css';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

Vue.config.productionTip = false;

// moment
moment.tz.setDefault(process.env.VUE_APP_TZ);
Vue.use(VueMoment, {
  moment
});

// Google Analytics設定
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_TRACKING_ID
  }
});

// API設定
Vue.use(StoreCoreApi);
Vue.use(CmsApi);

// 区分値処理の設定
Vue.use(Cls);

// 汎用パラメータ処理の設定
Vue.use(Gpr);

// メッセージ処理の設定
Vue.use(Msg);

// バリデーションの設定
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

// スクロール
Vue.use(VueScrollTo);

// エラーハンドリング処理の設定
Vue.use(ErrHandler);

// ログ出力処理の設定
Vue.use(VueLogger, {
  isEnabled: process.env.VUE_APP_ENV === 'local' ? true : false,
  logLevel: 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
});

Vue.mixin({
  methods: {
    showMessage(msg: string, color?: string) {
      StoreModule.addMessage(msg, color);
    },
    showErrorMessage(msg: string) {
      StoreModule.addErrorMessage(msg);
    },
    showInfoMessage(msg: string) {
      StoreModule.addInfoMessage(msg);
    },
    showWarnMessage(msg: string) {
      StoreModule.addWarnMessage(msg);
    },
    showSuccessMessage(msg: string) {
      StoreModule.addSuccessMessage(msg);
    }
  }
});

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
